import { ScanType } from '@/components/UploadCsvFile/utils';
import { notification } from 'antd';
import { RcFile } from 'antd/es/upload';
import { getI18n } from 'react-i18next';

export const downloadFileByURL = async (
  fileUrl: string,
  callbackSuccess: Function,
  callbackErr: Function,
) => {
  return fetch(fileUrl)
    .then(resp => resp.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      const filename = (fileUrl || '').split('/').pop() as string;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      if (callbackSuccess) callbackSuccess();
    })
    .catch(e => {
      if (callbackErr) callbackErr(e);
    });
};

//read csv file before upload
export const readCsvFileUploaded = (file: RcFile) => {
  const reader = new FileReader();

  reader.onload = e => {
    const fileInfo = e?.target?.result;
    if (!fileInfo) return;
    const csvInfo = String(fileInfo).split('\n');
    const [titles, ...rest] = csvInfo;

    const _csvHeader = titles.split(',');
    const _csvData = rest.reduce((res: string[][], curr) => {
      const eachRowData = curr.split(',');
      if (!eachRowData.length) return res;
      return [...res, eachRowData];
    }, []);
  };

  reader.readAsText(file);
};

export function downloadFILE(url: string, name = '') {
  let link = document.createElement('a');
  link.setAttribute('download', name);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

const listSampleFiles = {
  [ScanType.SEQUENCING_BATCH]: 'batch-files/List-DNA-Sample-IDs.csv',
  [ScanType.EXTRACTION_BATCH]: 'batch-files/List-DNA-Conc-Sample.csv',
};
export const downloadSampleFile = async (
  e: React.FormEvent<HTMLAnchorElement>,
  action: ScanType,
) => {
  e.preventDefault();
  const i18n = getI18n();
  const fileUrl = `${window.location.origin}/${listSampleFiles[action]}`;

  try {
    const resp = await fetch(fileUrl);
    const blob = await resp.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    const filename = (fileUrl || '').split('/').pop() as string;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  } catch {
    notification.success({
      message: i18n.t('kit.downloadFileFailed'),
    });
  }
};
